import React, { useState } from "react";
import "./CloudBenefits.css";
import img1 from '../cloudassets/cloud1.png';
import img2 from '../cloudassets/cloud2.png';
import img3 from '../cloudassets/cloud3.png';
import img4 from '../cloudassets/cloud4.png';
import img5 from '../cloudassets/cloud5.png';
import img6 from '../cloudassets/cloud6.png';

export default function CloudBenefits() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const cards = [                   
    {
      id: 1,
      img:img1,
      title: "Tokenization Platform",
      description:
        "As a leading dApp development company, we deliver feature-rich tokenization solutions for blockchain asset digitization. Our enterprise-grade platforms help businesses unlock new financial opportunities, enabling secure, tradeable digital assets and improved liquidity.",
    },
    {
      id: 2,
      img:img2,
      title: "DAO Development",
      description:
        "Our DAO development services help businesses build decentralized, community-governed organizations using smart contracts. We create frameworks that support transparent governance, collaborative decision-making, and scalable growth.",
    },
    {
      id: 3,
      img:img3,
      title: "DeFi Application Development",
      description:
        "Our DeFi development services create blockchain-powered financial solutions that remove intermediaries and give users full control of their assets. We build DeFi platforms like lending protocols, DEXs, and yield farming apps to promote financial inclusion and accessibility.",
    },
    {
      id: 4,
      img:img4,
      title: "NFT Marketplace Development",
      description:
        "Our NFT marketplace development services support the growing demand for digital collectibles and unique assets. We build secure, feature-rich marketplaces where creators and collectors can mint, buy, sell, and trade NFTs with ease.",
    },
    {
      id: 5,
      img:img5,
      title: "Smart Contract Development",
      description:
        "Our smart contract development services create secure, audited, and efficient contracts using Solidity, Vyper, and Rust. We automate agreements, enable seamless transactions, and ensure reliability, transparency, and compliance with industry best practices.",
    },
    {
      id: 6,
      img:img6,
      title: "dApp Consulting",
      description:
        "Our dApps consulting services hinge on our differentiating ability to understand the market forces and the disruptive technology ecosystem. We gauge your requirements, assess blockchain’s applicability in your as-in organizational landscape, and create solutions that act as growth engines.",
    },
  ];

  return (
    <div id="cloud-benefits" className="cloudmainclass">
     <div className="top">
            <h2 className="heading">
     Start Your AI Journey Today</h2>
      <p className="subheading">
    A clear, practical, and outcome-focused approach to building and scaling GenAI solutions, step by step.  
    </p>
    </div>
      <div className="cards">
        {cards.map((card) => (
          <div className="card" key={card.id}>
            <img src={card.img} alt="error" />
            <h3>{card.title}</h3>
            <span>{card.description}</span>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {cards.map((card) => (
              <div className="carousel-card" key={card.id}>
                 <img src={card.img} alt="error" />
                <h3>{card.title}</h3>
                <span>{card.description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="carousel-dots">
        {cards.map((_, index) => (
          <button
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}
